import {OrderDto} from '../../types'
import {compareLifeCycle, LifeCycleEvent} from '../lifeCycle'

/**
 * Determines if plus load functionality is enabled for the given order.
 * Plus load is enabled only after the last truck has been loaded.
 *
 * @param order - Order data to check
 * @returns true if plus load is enabled, false otherwise
 */
export const isPlusLoadEnabled = (order: OrderDto): boolean => {
  return compareLifeCycle(order, LifeCycleEvent.LastTruckLoaded) === 'after'
}
